import ContactFormSectionImplementation from '../implementation/sections/ContactFormSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiContactFormSectionDTO,
  ContactFormSectionDTO,
} from '@lib/strapi/dtos/components/sections/contactFormSection.dto';

const ContactFormSection = (props: ComponentProps<ContactFormSectionDTO>) => {
  return <ContactFormSectionImplementation {...props}></ContactFormSectionImplementation>;
};

export default ContactFormSection;
